export default __webpack_public_path__ + "assets/images/up-before-5f81c80b.svg";